import React, { useEffect, useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import "./login.css";
import "bootstrap/dist/css/bootstrap.css";
import { withTranslation } from "react-i18next";
import Formulario from "./formulario";
import FormularioWhatsapp from "./formularioWhatsapp";

const helmetContext = {};

function Login(props) {
  const [logo, setLogo] = useState('');
  const [telefonoWhatsapp, setTelefonoWhatsapp] = useState("");
  const [plataforma, setPlataforma] = useState("");


  useEffect(() => {
    getconfiguracionLocal();
  });

  const getconfiguracionLocal = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(
      "/api/dataLocalLogin?local=" + props.match.params.id,
      requestOptions
    );
    const result = await response.json();
    setLogo(result.local.logo);
    setPlataforma(result.local.plataforma);
    if (result.local.plataforma) {
      setTelefonoWhatsapp(result.local.whatsapp);
    }
  };

    return (
      <>
        <HelmetProvider context={helmetContext}>
          <title>Login MC</title>
          <link href="/favicon.ico" rel="shortcut icon" type="image/x-icon" />
        </HelmetProvider>
        <header></header>
        <main>
          {telefonoWhatsapp && (
            <FormularioWhatsapp
              logo={logo}
              telefonoWhatsapp={telefonoWhatsapp}
              plataforma={plataforma}
              id={props.match.params.id}
            ></FormularioWhatsapp>
          )}
          {!telefonoWhatsapp && (
            <Formulario
              logo={logo}
              plataforma={plataforma}
              id={props.match.params.id}
            ></Formulario>
          )}
        </main>
      </>
    );
}

export default withTranslation()(Login);
